module.exports = __webpack_public_path__ + "static/00006.455b053d.jpg";